import { Navigate } from 'react-router-dom';

import { MLB_PLAY_LINEUPS } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { OffseasonPlayPage } from 'components/playPage/OffseasonPlayPage';

const MLBPlayPage = () => {
  const {
    flags: { useMlbOffseason = false },
  } = useFeatureFlags();

  if (useMlbOffseason) {
    return <OffseasonPlayPage />;
  }

  return <Navigate to={MLB_PLAY_LINEUPS} replace />;
};

export default MLBPlayPage;
